import React, { Component } from 'react';
import './column.css';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import Task from './task/task';
import { FiTrash2, FiPlusCircle, FiCheck, FiX } from 'react-icons/fi';
import UniqId from 'uniqid';

export default class Column extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isNewItemEnbled: false,
      newTaskContent: '',
      error: ''
    };
  }

  toggleIsNewTaskInput = () => {
    this.setState({
      isNewItemEnbled: !this.state.isNewItemEnbled,
      newTaskContent: '',
      error: ''
    });
  };

  addnewItem = () => {
    if (this.state.newTaskContent) {
      const newItem = {
        id: UniqId(),
        content: this.state.newTaskContent,
        dueTime: new Date()
      };
      this.props.addTaskToColumn(
        this.props.taskBoardId,
        this.props.column.id,
        newItem
      );
      this.toggleIsNewTaskInput();
      this.props.updateItemToRender();
    } else {
      this.setState({
        error: "I think you didn't type anything !"
      });
    }
  };

  handleNewTaskChange = event => {
    this.setState({
      newTaskContent: event.target.value
    });
  };

  render() {
    return (
      <Draggable draggableId={this.props.column.id} index={this.props.index}>
        {provided => (
          <div
            className="column-container"
            {...provided.draggableProps}
            ref={provided.innerRef}>
            <h4
              className="column-title"
              style={{ color: this.props.themeColor }}>
              <span className="column-title-span" {...provided.dragHandleProps}>
                {this.props.column.title} /{' '}
                {Object.keys(this.props.tasks).length}
              </span>
              <span className="column-actions">
                <FiTrash2
                  onClick={() => {
                    this.props.deleteExistingColumn(
                      this.props.taskBoardId,
                      this.props.column.id
                    );
                    this.props.updateItemToRender();
                  }}
                />
                {this.state.isNewItemEnbled && (
                  <FiX
                    onClick={() => {
                      this.toggleIsNewTaskInput();
                    }}
                  />
                )}
                {this.state.isNewItemEnbled ? (
                  <FiCheck
                    onClick={() => {
                      this.addnewItem();
                    }}
                  />
                ) : (
                  <FiPlusCircle
                    onClick={() => {
                      this.toggleIsNewTaskInput();
                    }}
                  />
                )}
              </span>
            </h4>
            {this.state.isNewItemEnbled && (
              <div className="add-new-task-column">
                <textarea
                  cols="30"
                  rows="5"
                  value={this.state.newTaskContent}
                  onChange={e => this.handleNewTaskChange(e)}
                  placeholder="New Task.."
                />
                <p>{this.state.error}</p>
              </div>
            )}
            <Droppable droppableId={this.props.column.id} type="task">
              {provided => (
                <div
                  className="task-list"
                  ref={provided.innerRef}
                  {...provided.droppableProps}>
                  {this.props.tasks.map((task, index) => (
                    <Task
                      key={task.id}
                      task={task}
                      index={index}
                      boardID={this.props.taskBoardId}
                      colID={this.props.column.id}
                      deleteExistingTask={this.props.deleteExistingTask}
                      updateItemToRender={this.props.updateItemToRender}
                    />
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        )}
      </Draggable>
    );
  }
}
